<template>
  <div>
    <div class="dividerWithText ">oder</div>
    <div
      style="display: flex; justify-content: center">
      <v-btn
        v-if="isSocialMediaGoogleActive"
        id="signInGoogleBtn"
        :fab="$vuetify.breakpoint.xsOnly"
        class="ma-2"
        color="fin-color-primary-dark"
        outlined
        type="button"
        @click="submitGoogle">
        <v-icon :class="$vuetify.breakpoint.xsOnly ? '' : 'mr-3'">
          mdi-google
        </v-icon>
        <span v-if="$vuetify.breakpoint.smAndUp"> Mit Google anmelden</span>
      </v-btn>
      <v-btn
        v-if="isSocialMediaAppleActive"
        id="signInAppleBtn"
        :fab="$vuetify.breakpoint.xsOnly"
        class="ma-2"
        color="fin-color-primary-dark"
        outlined
        type="button"
        @click="submitApple">
        <v-icon :class="$vuetify.breakpoint.xsOnly ? '' : 'mr-3'">
          mdi-apple
        </v-icon>
        <span v-if="$vuetify.breakpoint.smAndUp"> Mit Apple anmelden </span>
      </v-btn>
    </div>
  </div>
</template>

<script>

import {mapActions} from "vuex"

export default {
  name: 'FinSocialMediaSignIn',
  components: {},
  props: {
    isSocialMediaAppleActive: {
      type: Boolean,
      default: false
    },
    isSocialMediaGoogleActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    ...mapActions('auth', ['federatedSignInGoogle', 'federatedSignInApple']),
    async submitApple() {
      await this.federatedSignInApple()
      this.$nextTick(() => {
        this.$emit('socialLoginInProgress', true)
      })
    },
    async submitGoogle() {
      await this.federatedSignInGoogle()
      this.$nextTick(() => {
        this.$emit('socialLoginInProgress', true)
      })
    },
  }
}

</script>


<style lang="scss" scoped>
/*
::v-deep .v-input__append-inner {
  margin-top: 15px !important;
}*/

.dividerWithText {
  display: flex;
  flex-basis: 100%;
  align-items: center;
  color: rgba(0, 0, 0, 0.50);
  margin: 8px 0px;
}

.dividerWithText:before,
.dividerWithText:after {
  content: "";
  flex-grow: 1;
  background: rgba(0, 0, 0, 0.12);
  height: 1px;
  font-size: 0px;
  line-height: 0px;
  margin: 0px 8px;
}
</style>
